import React from 'react';
import PropTypes from 'prop-types';

const RegistrationRequestDetails = props => {
  return (
    <div className={"row"}>
      <div className={"col-12"}>
        <div>
          <strong>Name:</strong> {props.request.firstName} {props.request.lastName}
        </div>
        <div>
          <strong>Company:</strong> {props.request.company}
        </div>
        <div>
          <strong>Email:</strong> {props.request.email}
        </div>
        <div>
          <strong>Message:</strong> {props.request.message}
        </div>
      </div>  
    </div>
  );
};

RegistrationRequestDetails.propTypes = {
  request: PropTypes.object.isRequired, 
};

export default RegistrationRequestDetails;
